import * as CryptoJS from 'crypto-js'
import * as openpgp from 'openpgp'

export function encrypt (state, data, id) {
  const key = state.auth?.authId || id
  if (!key) {
    // Remove console logging to prevent information disclosure
    return null
  }
  return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString()
}

export function decrypt (state, data, id) {
  const key = state.auth?.authId || id
  if (!key) {
    // Remove console logging to prevent information disclosure
    return null
  }
  return JSON.parse(CryptoJS.AES.decrypt(data, key).toString(CryptoJS.enc.Utf8))
}

export async function encryptWithKey (data, publicKeyArmored) {
  if (!publicKeyArmored) {
    // Remove console logging to prevent information disclosure
    return null
  }
  const dataString = JSON.stringify(data)
  const publicKey = await openpgp.readKey({ armoredKey: publicKeyArmored })
  const encrypted = await openpgp.encrypt({
    message: await openpgp.createMessage({ text: dataString, format: 'text' }),
    encryptionKeys: publicKey
  })

  if (encrypted) {
    return encrypted
  }

  throw new Error('Error encrypting data')
}

export async function decryptWithKey (passphrase, encrypted, privateKeyArmored, publicKeyArmored) {
  try {
    if (!privateKeyArmored || !publicKeyArmored) {
      throw new Error('Private and public keys are required for decryption')
    }

    console.log('[DECRYPT] Starting decryption process', {
      passphraseLength: passphrase?.length,
      encryptedDataLength: encrypted?.length,
      hasPrivateKey: !!privateKeyArmored,
      hasPublicKey: !!publicKeyArmored
    })

    let privateKey = await openpgp.readPrivateKey({ armoredKey: privateKeyArmored })
    const publicKey = await openpgp.readKey({ armoredKey: publicKeyArmored })

    console.log('[DECRYPT] Keys loaded', {
      privateKeyDecrypted: privateKey.isDecrypted(),
      publicKeyFingerprint: publicKey.getFingerprint()
    })

    if (!privateKey.isDecrypted()) {
      console.log('[DECRYPT] Decrypting private key with passphrase')
      privateKey = await openpgp.decryptKey({ privateKey, passphrase })
      console.log('[DECRYPT] Private key decrypted successfully')
    }

    const message = await openpgp.readMessage({ armoredMessage: encrypted })
    console.log('[DECRYPT] Message parsed, attempting decryption')

    // FIX: Remove verificationKeys parameter since expectSigned: false
    // The message is NOT signed, so we don't need verification keys
    const { data } = await openpgp.decrypt({
      message,
      decryptionKeys: privateKey,
      expectSigned: false
    })

    console.log('[DECRYPT] Decryption successful', {
      dataLength: data?.length
    })

    return data
  } catch (error) {
    console.error('[DECRYPT] Decryption failed:', {
      errorMessage: error.message,
      errorStack: error.stack,
      errorType: error.constructor.name
    })

    if (error.message.includes('Session key decryption failed')) {
      return 'expired'
    }
    return null
  }
}

export async function generatePair (id) {
  const { privateKey, publicKey } = await openpgp.generateKey({
    type: 'ecc',
    curve: 'curve25519',
    userIDs: [{ id }],
    passphrase: id
  })

  return {
    privateKey,
    publicKey
  }
}
